import {
    ComponentsOverrides,
    ComponentsProps,
    ComponentsVariants,
    Theme,
} from '@mui/material';

interface M3SvgIcon {
    MuiSvgIcon: {
        defaultProps?: ComponentsProps['MuiSvgIcon'];
        styleOverrides?: ComponentsOverrides<Theme>['MuiSvgIcon'];
        variants?: ComponentsVariants['MuiSvgIcon'];
    };
}

const rtlFlipIcons = [
    'SendRoundedIcon',
    'SaveRoundedIcon',
    'ScheduleSendRoundedIcon',
    'CancelScheduleSendRoundedIcon',
    'ScheduleSendOutlinedIcon',
    'SendOutlinedIcon',
    'ChevronLeftRoundedIcon',
    'ChevronRightRoundedIcon',
];

export const getSvgIcon = (theme: Theme): M3SvgIcon => {
    return {
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    ...(document.documentElement.dir === 'rtl' && {
                        [`&[data-testid="${rtlFlipIcons.join('"], &[data-testid="')}"]`]:
                            {
                                transform: 'scaleX(-1)',
                            },
                    }),
                },
            },
        },
    };
};
